export class AssignAddressToExistingBuildingDTO {
  oldBuildingId: string;
  newBuildingId: string;
  addressId: string;

  constructor(dto: {
    oldBuildingId?: string;
    newBuildingId?: string;
    addressId?: string;
  }) {
    this.oldBuildingId = dto.oldBuildingId;
    this.newBuildingId = dto.newBuildingId;
    this.addressId = dto.addressId;
  }
}
